import styled from 'styled-components';
import { Select } from 'antd';

export const SDropdownContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SSelect = styled(Select)`
  width: 100%;
  height: 40px !important;
`;

export const SDropdownContent = styled.div`
  .ant-select-item {
    padding: 6px 8px;

    &:hover {
      background-color: #e9f7f7;
    }

    &.ant-select-item-option-selected {
      background-color: #e9f7f7;
    }
  }

  .ant-select-item-group {
    background-color: #f4f5f8;
    font-weight: 700 !important;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.88);
    padding: 8px 12px !important;
    cursor: default;
    border-top: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    min-height: 40px;

    &:first-child {
      border-top: none;
    }
  }

  .ant-select-item-option-grouped {
    padding-left: 24px !important;
  }
`;

export const SEmptyState = styled.div`
  padding: 16px;
  text-align: center;
  color: #8c8c8c;
  font-size: 14px;
`;
